export default import.meta.ROLLUP_FILE_URL_gOpBNSELCNdnM_yZlyA5OQ;